import React, { useState } from 'react';
import styled from 'styled-components';
import { Modal } from '/imports/ui/Modal';
import { Button } from '/imports/ui/Button';
import { Checkbox } from '/imports/ui/Checkbox';
import { NumberInput } from '/imports/ui/NumberInput';
import { Form } from '/imports/ui/Form';
import { FormField } from '/imports/ui/FormField';
import { strings } from '/imports/strings';

const FootprintFiltersModalStyled = styled(Modal)`
  .modal-title {
    font-size: 1.5rem;
  }
  .modal-window {
    min-width: 22rem;
  }
  .modal-buttons {
    justify-content: flex-end;
  }
  .checkbox-row {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin-top: 0.5rem;
    input {
      margin: 0;
      margin-top: 0.5rem;
    }
    label {
      margin-right: 0 !important;
    }
  }
  .field {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1rem;
    label {
      text-align: right;
      margin-right: 1rem;
    }
  }
`;

export interface FootprintFilters {
  minRoofArea: number;
  maxRoofArea: number;
  limitResults: number;
  includeResi: boolean;
}

interface Props {
  filters: FootprintFilters;
  onApply: (filters: FootprintFilters) => void;
  onClose: () => void;
}

/** Modal for editing building-footprint search filters. */
export const FootprintFiltersModal = (props: Props) => {
  const [minRoofArea, setMinRoofArea] = useState(props.filters.minRoofArea);
  const [maxRoofArea, setMaxRoofArea] = useState(props.filters.maxRoofArea);
  const [limitResults, setLimitResults] = useState(props.filters.limitResults);
  const [includeResi, setIncludeResi] = useState(props.filters.includeResi);
  /** Emit the current filter values and close. */
  const apply = () => {
    props.onApply({ minRoofArea, maxRoofArea, limitResults, includeResi });
    props.onClose();
  };
  return (
    <FootprintFiltersModalStyled title={strings.Filters()} onClose={props.onClose}>
      <Form onSubmit={apply}>
        <FormField field="minRoofArea">
          <label>{strings.MinimumRoofArea()} (sq.ft.)</label>
          <NumberInput value={minRoofArea} onChange={(v) => setMinRoofArea(v ?? 0)} />
        </FormField>
        <FormField field="maxRoofArea">
          <label>{strings.MaximumRoofArea()} (sq.ft.)</label>
          <NumberInput value={maxRoofArea} onChange={(v) => setMaxRoofArea(v ?? Number.MAX_SAFE_INTEGER)} />
        </FormField>
        <FormField field="limitResults">
          <label>{strings.LimitResults()}</label>
          <NumberInput value={limitResults} onChange={(v) => setLimitResults(v ?? 0)} />
        </FormField>
        <FormField field="includeResi">
          <label className="checkbox-row">
            <Checkbox checked={includeResi} onChange={setIncludeResi} />
            <span>{strings.IncludeResidential()}</span>
          </label>
        </FormField>
        <div className="modal-buttons">
          <Button className="primary" onClick={apply}>{strings.Apply()}</Button>
        </div>
      </Form>
    </FootprintFiltersModalStyled>
  );
};
